export default function formatMoney(amount = 0) {
  const options = {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  };

  // check if it's a clean currency amount
  if (amount % 100 === 0) {
    options.minimumFractionDigits = 2;
  }
  const formatter = Intl.NumberFormat("es-MX", options);

  return formatter.format(amount);
}

export const formatNumber = (number) => {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
  }).format(number);
};
